import { render, staticRenderFns } from "./RemoteControl.vue?vue&type=template&id=c87e6c84&"
import script from "./RemoteControl.vue?vue&type=script&lang=js&"
export * from "./RemoteControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports